import { useContext, useEffect, useState } from "react";
import { Grid, Stack, Typography } from "@mui/material";
// import moment from "moment";
import dayjs from "dayjs";
//Import from project
import StudentIcon from "../../Assets/icon_dasboard/graduation.png";
import TeacherIcon from "../../Assets/icon_dasboard/business.png";
// import ClassIcon from "../../Assets/icon_dasboard/music.png";
import OweIcon from "../../Assets/icon_dasboard/recurring_owe.png";
import RevenueIcon from "../../Assets/icon_dasboard/recurring.png";
import "./dashboardstyle.scss";
// import InvoiceImage from "../../Assets/new-dashboard/invoice-img.png";
// import OweImage from "../../Assets/new-dashboard/income-img.png";
import { currencyFormat } from "../../Function/DynamicFn";
import { AuthContext } from "../../Context/AuthContext";
import useGetHeaderCard from "../../Hooks/useGetHeaderCard";
import useGetTotalRevenueByYear from "../../Hooks/useGetTotalRevenueByYear";
import SelectYar from "./SelectYear";

const HeaderCard = () => {
  // Change Language
  const { t } = useContext(AuthContext);
  // const [filterYear, setFilterYear] = useState(dayjs(moment().format("YYYY")));
  const [filterYear, setFilterYear] = useState(dayjs().year());
  // console.log("filterYear:", filterYear);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { tableData } = useGetHeaderCard();
  const { totalData } = useGetTotalRevenueByYear({
    year: filterYear.toString(),
  });
  // console.log("totalData::", totalData);

  const headerData = [
    {
      cardName: t("total_student"),
      total: tableData?.totalStudent
        ? tableData?.totalStudent + ` ${t("pax")}`
        : "loading...",
      icon: StudentIcon,
      className: "first",
    },
    {
      cardName: t("total_teacher"),
      total: tableData?.totalTeacher
        ? tableData?.totalTeacher + ` ${t("pax")}`
        : "loading...",
      icon: TeacherIcon,
      className: "second",
    },
    // {
    //   cardName: t("total_class"),
    //   total: tableData?.totalClass,
    //   icon: ClassIcon,
    //   className: "third",
    // },
    {
      cardName: t("total_owe"),
      total: tableData?.totalOwe
        ? currencyFormat(tableData?.totalOwe)
        : "loading...",
      icon: OweIcon,
      className: "fourth",
    },
    // {
    //   cardName: t("total_revenue"),
    //   total: currencyFormat(tableData?.totalRevenue),
    //   icon: RevenueIcon,
    //   className: "fifth",
    // },
  ];

  return (
    <div className="card-container">
      {/* <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <Box className="card-container">
            <Stack
              direction="column"
              justifyContent="space-between"
              className="card-item-third"
            >
              <Stack direction="row" spacing={1}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className="icons-bg"
                >
                  <img alt="Income" src={InvoiceImage} className="icon" />
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Typography
                    className={
                      language === "en" ? "card-title" : "card-title-kh"
                    }
                  >
                    សិស្សសរុប
                  </Typography>
                  <Typography className="sub-title">
                    {tableData?.countInvoice ? tableData?.countInvoice : 0}
                  </Typography>
                </Stack>
              </Stack>

              <Typography
                className={language === "en" ? "notice-txt" : "notice-txt-kh"}
              >
                {t("since_start")}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <Box className="card-container">
            <Stack
              direction="column"
              justifyContent="space-between"
              className="card-item-fourth"
            >
              <Stack direction="row" spacing={1}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className="icons-bg"
                >
                  <img alt="Income" src={OweImage} className="icon" />
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Typography
                    className={
                      language === "en" ? "card-title" : "card-title-kh"
                    }
                  >
                    គ្រូបង្រៀន
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <Typography className="sub-title">
                      {tableData?.totalOweKhr ? tableData?.totalOweKhr : "0"}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Typography
                className={language === "en" ? "notice-txt" : "notice-txt-kh"}
              >
                {t("since_start")}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <Box className="card-container">
            <Stack
              direction="column"
              justifyContent="space-between"
              className="card-item-fifth"
            >
              <Stack direction="row" spacing={1}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className="icons-bg"
                >
                  <img alt="Income" src={OweImage} className="icon" />
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Typography
                    className={
                      language === "en" ? "card-title" : "card-title-kh"
                    }
                  >
                    ថ្នាក់រៀន
                  </Typography>
                  <Typography className="sub-title">
                    {tableData?.totalOweUsd ? tableData?.totalOweUsd : "0"}
                  </Typography>
                </Stack>
              </Stack>

              <Typography
                className={language === "en" ? "notice-txt" : "notice-txt-kh"}
              >
                {t("since_start")}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <Box className="card-container">
            <Stack
              direction="column"
              justifyContent="space-between"
              className="card-item-fifth"
            >
              <Stack direction="row" spacing={1}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className="icons-bg"
                >
                  <img alt="Income" src={OweImage} className="icon" />
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Typography
                    className={
                      language === "en" ? "card-title" : "card-title-kh"
                    }
                  >
                    ចំណូលក្នុងខែនេះ
                  </Typography>
                  <Typography className="sub-title">
                    {tableData?.totalOweUsd
                      ? currencyFormat(tableData?.totalOweUsd)
                      : "$ 0.00"}
                  </Typography>
                </Stack>
              </Stack>

              <Typography
                className={language === "en" ? "notice-txt" : "notice-txt-kh"}
              >
                {t("since_start")}
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid> */}
      <Grid container spacing={3}>
        {headerData?.map((data, index) => {
          return (
            <Grid item xs={12} sm={12} md={6} lg={3} xl={3} key={index}>
              <Stack
                direction="row"
                justifyContent="space-between"
                className={`stack-container-${data?.className}`}
              >
                <Stack direction="column" justifyContent="space-between">
                  <Typography className="text-number">
                    {/* {index === 3 || index === 4 ? "$ " : ""} */}
                    {index === 2 || index === 3 ? "$ " : ""}
                    {data?.total}
                  </Typography>
                  <Typography className="text-title">
                    {data?.cardName}
                  </Typography>
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className="icon-container"
                  >
                    <img
                      src={data?.icon}
                      alt="ThirdShareImg"
                      className="front-icon"
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          );
        })}

        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            className={`stack-container-fifth`}
          >
            <Stack direction="column" justifyContent="space-between">
              <Typography className="text-number">
                $ {currencyFormat(totalData)}
              </Typography>

              <Stack direction="row" spacing={1}>
                <Typography className="text-title">
                  {t("total_revenue")}
                </Typography>
                <Typography
                  className="text-title"
                  sx={{ cursor: "pointer" }}
                  onClick={handleOpen}
                >
                  ({filterYear})
                </Typography>
              </Stack>
            </Stack>

            {open && (
              <SelectYar
                open={open}
                handleClose={handleClose}
                filterYear={filterYear}
                setFilterYear={setFilterYear}
              />
            )}

            <Stack direction="column" justifyContent="center">
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                className="icon-container"
              >
                <img
                  src={RevenueIcon}
                  alt="ThirdShareImg"
                  className="front-icon"
                />
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderCard;
